import React from "react";
import CommonManagementSection from "./CommonManagementSection";


class FundRaiseSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {
        return (
            <div id='fundRaise' className='lndSolutionEachSec'>
                <div className='lndSoltopHead'>
                    <h3>Fund Raise</h3>
                    <p>Embrace the power of Zero-cost Fundraising, reduced Overhead Costs, Expensive Promotions, and High Transaction Fees.</p>
                </div>
                <div className='specialGridCol'>
                    <CommonManagementSection sectionType={"FUND_RAISE"} />

                    <div className='lndSPCol lndSolRightInfoBlk'>
                        <h4>Bring Transparency, Cost Saving, and Global Participation</h4>
                        <ul className='lndSolLists'>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolIco-1.svg"} alt='' /></figure>
                                <div>
                                    <h5>Transparency</h5>
                                    <p>Record your activities for donor's reference effortlessly</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolIco-2.svg"} alt='' /></figure>
                                <div>
                                    <h5>Zero Transaction Costs</h5>
                                    <p>Receive funds directly in your account</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolIco-3.svg"} alt='' /></figure>
                                <div>
                                    <h5>One-Window Collaboration</h5>
                                    <p>Manage fund raise, invite participants, update donors, monitor stats</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolIco-4.svg"} alt='' /></figure>
                                <div>
                                    <h5>Global Participation</h5>
                                    <p>Share link across platforms with real-time updates</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolIco-5.svg"} alt='' /></figure>
                                <div>
                                    <h5>Lower Promotional Costs</h5>
                                    <p>Customize  FAQ with project details</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default FundRaiseSection;